import React, { ReactNode } from "react";

import MobileProfileHeader from "./components/MobileProfileHeader";
import classNames from "classnames";
import CopounHeader from "@shared/components/coupon-header/CouponHeader";
import { profileMenu } from "./helpers/profileMenuItem";
import { useProfileLayout } from "./hooks/useProfileLayout";
import ProfileSideMenu from "./components/common/ProfileSideMenu";

interface ProfileProps {
  defaultSelected?: string;
  revalidate?: boolean;
  withAdminHeader?: boolean;
  hideBorder?: boolean;
  backButton?: {
    label: string;
    href: string;
  };
  floatingChildren?: React.ReactNode;
  element?: React.ReactElement;
  hideBottomNavigation?: boolean;
  children?: ReactNode;
}

const ProfileLayout: React.FC<ProfileProps> = ({
  children,
  defaultSelected,
  revalidate,
  withAdminHeader = false,
  hideBorder = false,
  backButton,
  floatingChildren,
  element,
  hideBottomNavigation = false,
}) => {
  const {
    selected,
    setSelected,
    logout,
    profileName,
    userData,
    showBanner,
    isAdmin,
    expire,
    closeBanner,
    product,
    courseCouponUrl,
    marginContainer,
    setCloseBanner,
    contentRef,
  } = useProfileLayout({ defaultSelected, revalidate, withAdminHeader });

  return (
    <>
      <div className="fds-md:block fds-lg:mx-auto hidden my-8 px-6 bg-transparent">
        <div className=" w-full   gap-x-6  bg-fds-primary flex flex-row">
          <ProfileSideMenu
            selected={selected}
            setSelected={setSelected}
            profileMenu={profileMenu}
            logout={logout}
            profileName={profileName || ""}
            email={userData?.user?.email || ""}
            mobile={userData?.user?.mobile || ""}
            showBanner={showBanner}
            isAdmin={isAdmin}
          />

          <div
            className={classNames(
              "w-full fds-lg:w-[894px] min-w-0   box-border  rounded-16  bg-fds-primary ",
              hideBorder ? "" : "border border-fds-default"
            )}
          >
            {expire?.can_purchase && !closeBanner && product && (
              <div className="p-6">
                <CopounHeader
                  canPurchaseAfterCoupon={expire.can_purchase}
                  expireDateFormatted={expire.window_end_at_formatted}
                  percentAfterCoupon={expire.value_percent}
                  price={product?.price || 0}
                  productName={product?.name || ""}
                  closeBanner={() => setCloseBanner(true)}
                  courseCouponUrl={courseCouponUrl}
                  productId={product?.id || ""}
                  isProfile={true}
                  expiryStatus={expire.expiry_status}
                />
              </div>
            )}
            <div ref={contentRef} className="w-full h-full">
              {children}
            </div>
            {floatingChildren}
          </div>
        </div>
      </div>
      <div className="block fds-md:hidden w-full">
        <MobileProfileHeader
          isAdmin={withAdminHeader}
          selected={selected}
          profileMenu={profileMenu}
          backButton={backButton}
          element={element}
        />
        <div
          className="w-full overflow-y-auto no-scrollbar mb-4 relative"
          style={{
            marginTop: `${marginContainer}px`,
            paddingBottom: hideBottomNavigation ? "" : "64px",
          }}
        >
          {expire?.can_purchase && !closeBanner && product && (
            <div className="p-6">
              <CopounHeader
                canPurchaseAfterCoupon={expire.can_purchase}
                expireDateFormatted={expire.window_end_at_formatted}
                percentAfterCoupon={expire.value_percent}
                price={product?.price || 0}
                productName={product?.name || ""}
                closeBanner={() => setCloseBanner(true)}
                courseCouponUrl={courseCouponUrl}
                productId={product?.id || ""}
                isProfile={true}
                expiryStatus={expire.expiry_status}
              />
            </div>
          )}
          {children}
        </div>
      </div>
    </>
  );
};

export default ProfileLayout;
